import React, { ReactNode } from 'react';

import AnimateHeight from 'react-animate-height';

import { CommentTime } from '@atlaskit/comment';
import { RelativeDate } from '@atlassian/bitkit-date';

import { FabricUser } from 'src/components/bbc-atlaskit-editor';
import {
  toBBUser,
  toFabricUser,
} from 'src/components/conversation-provider/utils';
import { UserAvatar } from 'src/containers/user-avatar';
import { useIntl } from 'src/hooks/intl';

import { messages } from './messages';
import * as styles from './styles';
import { Resolution } from './types';

type ConversationHeaderProps = {
  resolution?: Resolution | null;
  collapsed: boolean;
  user?: FabricUser;
  createdAt: string;
  renderAuthorAvatar?: (user?: FabricUser) => ReactNode;
  renderAuthorName?: (user?: FabricUser) => ReactNode;
};

const defaultRenderAvatar = (user?: FabricUser) => (
  <UserAvatar user={toBBUser(user)} />
);

const defaultRenderName = (user?: FabricUser) => <>{user?.name}</>;

/* eslint @typescript-eslint/ban-types: "warn" */
export const ConversationHeader: React.FC<ConversationHeaderProps> = ({
  resolution,
  collapsed,
  user,
  createdAt,
  renderAuthorAvatar = defaultRenderAvatar,
  renderAuthorName = defaultRenderName,
}) => {
  const intl = useIntl();
  if (resolution) {
    return (
      <styles.ResolvedHeaderWrapper>
        {renderAuthorAvatar(toFabricUser(resolution.user))}
        <styles.NameWrapper>
          {renderAuthorName(toFabricUser(resolution.user))}
        </styles.NameWrapper>
        {intl.formatMessage(messages.resolvedComment)}
      </styles.ResolvedHeaderWrapper>
    );
  }

  return (
    <AnimateHeight duration={250} height={collapsed ? 'auto' : 0}>
      <styles.CollapsedHeaderWrapper>
        {renderAuthorAvatar(user)}
        {renderAuthorName(user)}
        <CommentTime>
          <RelativeDate date={new Date(createdAt)} />
        </CommentTime>
      </styles.CollapsedHeaderWrapper>
    </AnimateHeight>
  );
};
